import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/priority-policies");

export const Route = createFileRoute("/priority-policies")({
  head: () => ({
    meta: [
      { title: "Priority policies — LevelLoad" },
      { name: "description", content: "Priority policies — LevelLoad transport planning." },
      { property: "og:title", content: "Priority policies — LevelLoad" },
      { property: "og:description", content: "Priority policies — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
